
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Tyres</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                The frequency of replacing car tyres depends on several factors, 
                including driving habits, road conditions, tyre type, and manufacturer 
                recommendations. However, a general guideline is to replace tyres 
                every <strong>5 years</strong>, or usually when they reach a tread depth of <strong>3mm</strong>. 
            </h1>
            
            <p>
                Here's why it's important:
            </p>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    <span class="dark:text-white">Safety:</span> Worn-out tyres can significantly compromise 
                    vehicle safety. As tyre treads wear down, they lose their ability to provide adequate traction, 
                    especially in wet or icy conditions.
                </p>

                <p>
                    <span class="dark:text-white">Handling and Performance:</span> Fresh tyres with sufficient tread 
                    depth contribute to better handling, cornering, and overall vehicle performance.
                </p>        

                <p>
                    <span class="dark:text-white">Fuel Efficiency:</span> Worn tyres can increase fuel consumption 
                    due to higher rolling resistance. As tyres lose tread depth, more energy is required to propel 
                    the vehicle forward, resulting in decreased fuel efficiency.
                </p>

                <p>
                    <span class="dark:text-white">Compliance and Legal Requirements:</span> In many regions, 
                    there are legal requirements regarding minimum tyre tread depth. Driving with tyres that 
                    have tread depths below the legal limit may result in fines or penalties.
                </p>        

            </div>

        </div>

    </div>   
    
</template>
